// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/css/index.scss';
import '@/assets/css/iosSelect.css';
import Confirm from '@/common/confirm';
import { getClientOS } from '@/utils/index';
import '@/utils/sentry';
import 'babel-polyfill';
//import sensors from 'sa-sdk-javascript'; //接入神策
import Vue from 'vue';
import VuePreview from 'vue-preview';
import App from './App';
import * as filters from "./filter"; //
import router from './router'; //路由
import directives from './utils/directives'; //通用方法
import request from './utils/request'; //ajax请求
import store from './utils/store'; //使用vuex状态管理
import tools from './utils/tools'; //弹框
import {
  Popup,
  Picker,
  Dialog,
  DatetimePicker,
  List,
  RadioGroup,
  Radio,
  Cell,
  Field,
  Button,
  ActionSheet,
  Icon,
  Popover,
  Toast
} from "vant";

let nextRouterPath = '';
Vue.use(Popover);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Field);
Vue.use(Button);
Vue.use(Cell);
Vue.use(List);
Vue.use(Confirm)
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Dialog);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(VuePreview, {
  mainClass: 'pswp--minimal--dark',
  barsSize: {
    top: 10,
    bottom: 0
  },
  captionEl: true,
  fullscreenEl: true,
  shareEl: false,
  bgOpacity: 0.85,
  tapToClose: false,
  tapToToggleControls: false,
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})
// Vue.use(preview, {
//   mainClass: 'pswp--minimal--dark',
//   barsSize: {top: 0, bottom: 0},
//   captionEl: false,
//   fullscreenEl: false,
//   shareEl: false,
//   bgOpacity: 0.85,
//   tapToClose: true,
//   tapToToggleControls: false
// })

Vue.use(directives);

//接入神策初始化
// sensors.init({
//   server_url: 'https://sensorsdata.julanling.com:4006/sa?project=default&token=5RxKUT0sZQp9Lz5XgCCOd',
//   show_log: false // 关闭控制台不输出
// });
//神策点位
Vue.prototype.setSensors = function (name, params) {
  const obj = {
    interview_platformsource: getClientOS()
  }
  params = {
    ...obj,
    ...params
  }
  // sensors && sensors.track(name, params)
}

router.beforeEach((to, from, next) => {
  nextRouterPath = to.fullPath
  // Vue.nextTick(() => {
  //   sensors.quick("autoTrackSinglePage", {
  //     platForm: "saas-app"
  //   });
  // });
  next();
});

router.afterEach(() => {
  nextRouterPath = null
})

window._routerLoadError = () => {
  nextRouterPath && router.push(nextRouterPath)
}
// 操作系统
//神策点位
// Vue.prototype.$sensors = sensors;
Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'wx-open-launch-weapp'
]

Vue.prototype.$http = request;
Vue.prototype.showToast = tools.showToast.bind(tools);
Vue.prototype.showLoading = tools.showLoading.bind(tools);
Vue.prototype.hideLoading = tools.hideLoading.bind(tools);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // components: {
  //   App
  // },
  render: h => h(App)
})
